import type { WireColor } from '@il-colpo/engine';

/** Colours for the wires; the name is always printed beside them, so colour is never the only cue. */
export const SWATCH: Record<WireColor, string> = {
  red: '#ff4d5a',
  blue: '#4d8dff',
  yellow: '#ffd23f',
  black: '#222222',
  white: '#f1f1f1',
  green: '#4dd47a',
};
